import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';

import nivelesImg from '../../assets/images/niveleshawkins.png';
import nostalgiaImg from '../../assets/images/nostalgia.png';
import nostalgiaNivelesPng from '../../assets/images/nostalgia_niveles.png';
import nostalgiaMp3 from '../../assets/audios/nostalgia.mp3';
import UrlConfig from '../../data/UrlConfig';

// --- Componente de Tarjeta de Contenido ---
const ContentCard = ({ children, className = '' }) => (
  <div className={`bg-gray-800/50 p-8 rounded-lg border border-gray-700 ${className}`}>
    {children}
  </div>
);

// --- Icono para el botón de descarga ---
const DownloadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
  </svg>
);

const NostalgiaPage = () => {
  const config = UrlConfig;
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [nick, setNick] = useState('');
  const [errors, setErrors] = useState({ email: '', nick: '' });
  const [mensajeExito, setMensajeExito] = useState('¡Tu audiolibro está en camino! Revisa tu carpeta de descargas.');
  const [user, setUser] = useState({});

  useEffect(() => {
    // Estilo inmersivo para la página
    document.body.className = 'bg-black text-white';
    document.title = 'Soltar el Pasado | Gustavo Aguiar';

    let data = localStorage.getItem('userSM');

    if (data) {
      let userSM = JSON.parse(data);
     userSM.nostalgiaDownloaded = userSM.statuses?.some(item => item.page === 'nostalgia' && item.section === 'fragmento' && item.status === 'downloaded');
      setEmail(userSM.email);
      setNick(userSM.nick);
      setUser(userSM);
    }

    // Limpieza al salir del componente
    return () => {
      document.body.className = ''; // Restaura las clases del body
      document.title = 'GUS • A • GUIAR';
    };
  }, []);

  const validar = () => {
    const nuevosErrores = { email: '', nick: '' };
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

     if (!emailRegex.test(email)) nuevosErrores.email = 'Ingresa un email válido.';
    if (!nick.trim()) nuevosErrores.nick = 'Tu nombre es obligatorio.';
    setErrors(nuevosErrores);
    return !nuevosErrores.email && !nuevosErrores.nick;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
   if (!validar()) return;

    const datos = { email, nick, page: 'nostalgia', section: 'fragmento', status: 'downloaded' };

    try {
      const response = await fetch(config.resourcesApi, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(datos),
      });

      const resultado = await response.json();

      if (resultado.status !== 'success') {
        throw new Error('Error en el servidor: ' + resultado.message);
      }

      const newStatus = { page: datos.page, section: datos.section, status: datos.status };
      const updatedUser = {
        ...user,
        email,
        nick,
        statuses: [...(user.statuses || []), newStatus],
        nostalgiaDownloaded: true,
      };

      localStorage.setItem('userSM', JSON.stringify(updatedUser));
      setUser(updatedUser);

      // Iniciar la descarga
      const link = document.createElement('a');
      link.href = nostalgiaMp3;
      link.download = 'Nostalgia - La Hermosa Mentirosa.mp3';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error('Error en la descarga:', error);
      alert('Ocurrió un error al intentar descargar el archivo. Por favor, intenta de nuevo.');
    }
  };

  const [heroRef, heroInView] = useInView({ threshold: 0.2, triggerOnce: true });
  const [formRef, formInView] = useInView({ threshold: 0.2, triggerOnce: true });
  const [whyRef, whyInView] = useInView({ threshold: 0.2, triggerOnce: true });
  const [howRef, howInView] = useInView({ threshold: 0.2, triggerOnce: true });
  const [ctaRef, ctaInView] = useInView({ threshold: 0.2, triggerOnce: true });

  return (
    <div className="bg-black text-white font-sans selection:bg-pink-500 selection:text-black">
      {/* --- Header --- */}
      <header className="absolute top-0 left-0 w-full p-6 z-30 flex justify-between items-center">
        <Link to="/" className="text-lg tracking-widest text-gray-400 hover:text-white transition-colors duration-300">
          GUS•A•GUIAR
        </Link>
        <Link to="/menu" className="text-sm font-semibold text-gray-400 hover:text-white transition-colors duration-300">
          MENÚ
        </Link>
      </header>

      {/* --- Hero Section --- */}
      <section ref={heroRef} className={`min-h-screen flex flex-col items-center justify-center text-center p-4 pt-24 sm:pt-16 bg-gray-900 ${heroInView ? 'animate-fade-in' : 'opacity-0'}`}>
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-white to-pink-400">
            Nostalgia: La Hermosa Mentirosa
          </h1>
          <p className="mt-6 text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto">
            Entiende por qué aferrarte al pasado te impide crear un futuro extraordinario y cómo puedes liberarte de esa carga emocional.
          </p>
        </div>
      </section>

      {/* --- Download Section --- */}
      <section ref={formRef} className={`py-20 sm:py-32 bg-black ${formInView ? 'animate-slide-in-left' : 'opacity-0 transform -translate-x-10'}`}>
        <div className="max-w-5xl mx-auto px-6 lg:px-8 grid md:grid-cols-2 gap-16 items-center">
          <div className="prose prose-invert prose-lg text-gray-300">
            <h2 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-white to-pink-400 mb-6">
              La trampa de los recuerdos
            </h2>
            <p>La nostalgia te muestra momentos destacados mientras oculta las razones por las que las cosas terminaron.</p>
            <p>Recorres fotos antiguas, revives conversaciones y te convences de que lo que se fue era mejor. Pero aferrarte a esos momentos te mantiene atrapado, viviendo en un pasado que ya no existe.</p>
            <h3 className="text-2xl font-semibold mt-10 text-white">Descarga el Audiolibro 👇</h3>
          </div>

          <div>
            {user.nostalgiaDownloaded ? (
              <ContentCard className="text-center">
                <p className="text-2xl font-bold text-green-400">¡Éxito!</p>
                <p className="mt-2 text-gray-300">{mensajeExito}</p>
                <button
                  onClick={() => navigate(0)} // Recarga la página para volver a descargar
                  className="mt-6 bg-pink-500 hover:bg-pink-600 text-white font-bold py-3 px-6 rounded-full transition-all duration-300 transform hover:scale-105"
                >
                  Descargar de Nuevo
                </button>
              </ContentCard>
            ) : (
              <ContentCard>
                <form onSubmit={handleSubmit} noValidate>
                  <div className="space-y-6">
                    <div>
                      <label htmlFor="nick" className="block text-sm font-medium text-gray-300 mb-2">Nombre</label>
                      <input
                        id="nick"
                        type="text"
                        value={nick}
                        onChange={(e) => setNick(e.target.value)}
                        className="w-full bg-gray-700 border-gray-600 text-white rounded-md px-4 py-3 focus:ring-2 focus:ring-pink-500 focus:border-pink-500 transition"
                        placeholder="Tu nombre"
                      />
                      {errors.nick && <p className="mt-2 text-sm text-red-400">{errors.nick}</p>}
                    </div>
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2">Email</label>
                      <input
                        id="email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full bg-gray-700 border-gray-600 text-white rounded-md px-4 py-3 focus:ring-2 focus:ring-pink-500 focus:border-pink-500 transition"
                        placeholder="tu@email.com"
                      />
                      {errors.email && <p className="mt-2 text-sm text-red-400">{errors.email}</p>}
                    </div>
                  </div>
                  <button type="submit" className="mt-8 w-full flex items-center justify-center bg-pink-500 hover:bg-pink-600 text-white font-bold text-lg py-4 px-8 rounded-full shadow-lg shadow-pink-500/30 transform hover:scale-105 transition-all duration-300">
                    <DownloadIcon />
                    Descargar MP3 Gratis
                  </button>
                </form>
              </ContentCard>
            )}
          </div>
        </div>
      </section>

      {/* --- Why Section --- */}
      <section ref={whyRef} className={`py-20 sm:py-32 bg-gray-900 ${whyInView ? 'animate-slide-in-right' : 'opacity-0 transform translate-x-10'}`}>
        <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold mb-6">¿Por qué la nostalgia es peligrosa?</h2>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto mb-12">
            Porque a menudo viene cargada de tristeza y añoranza. Nos hace evitar el presente, perdiéndonos en recuerdos que idealizamos. La melancolía, su lado oscuro, calibra en niveles de conciencia muy bajos, drenando nuestra energía vital.
          </p>
          <img src={nostalgiaNivelesPng} alt="Niveles de conciencia de la nostalgia" className="rounded-lg shadow-2xl shadow-black/50 mx-auto" />
        </div>
      </section>

      {/* --- How Section --- */}
      <section ref={howRef} className={`py-20 sm:py-32 bg-black ${howRef ? 'animate-fade-in' : 'opacity-0'}`}>
        <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold mb-6">¿Cómo hacemos para salir de ahí?</h2>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto mb-12">
            Elevando nuestro <strong>nivel de conciencia</strong>. La escala del Dr. Hawkins nos muestra un mapa claro para navegar hacia estados de mayor poder como el Coraje, la Neutralidad y la Disposición, donde recuperamos el control y la confianza en la vida.
          </p>
          <img src={nivelesImg} alt="Escala de niveles de conciencia del Dr. Hawkins" className="rounded-lg shadow-2xl shadow-black/50 mx-auto" />
        </div>
      </section>

      {/* --- Final CTA Section --- */}
      <section ref={ctaRef} className={`py-20 sm:py-32 bg-gray-900 ${ctaInView ? 'animate-slide-in-bottom' : 'opacity-0 transform translate-y-10'}`}>
        <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-serif text-4xl sm:text-5xl font-bold mb-6">Conecta con el poder del ahora.</h2>
          <p className="text-lg text-gray-300 mb-8">
            Te invito a la sección de los niveles de conciencia, donde podrás descargarte un PDF con actividades prácticas que te permitirán conectar con el momento presente y elevar tu frecuencia.
          </p>
          <Link
            to="/niveles"
            className="bg-pink-500 hover:bg-pink-600 text-white font-bold text-xl py-5 px-12 rounded-full shadow-lg shadow-pink-500/40 transform hover:scale-105 transition-all duration-300 inline-block"
          >
            IR A NIVELES DE CONCIENCIA
          </Link>
        </div>
      </section>

      {/* --- Footer --- */}
      <footer className="text-center py-8 border-t border-gray-800 bg-black">
        <p className="text-sm text-gray-500">&copy; {new Date().getFullYear()} Gus • Aguiar | En misión de elevar y transformar.</p>
        <div className="mt-4">
          <Link to="/menu" className="text-sm text-gray-400 hover:text-pink-300 transition-colors">
            ¿No encontraste lo que buscabas?
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default NostalgiaPage;
